import {ENDPOINTS} from './endpoints';
import {STYLE_CONFIG, resolveStyleConfig} from './styleConfig';

const CURRENCY_POSITIONS = [
  'left',
  'left-spaced',
  'right',
  'right-spaced',
] as const;

type CurrencyPosition = (typeof CURRENCY_POSITIONS)[number];

const DEBUG = true;
// const BASE_URL = 'http://127.0.0.1:8000';
const BASE_URL = 'https://api.choosingdemo.com';
const AUTHORIZATION_TOKEN =
  'wVcevaUJ1T7yW1KDFpavBve30lMDf1qJzzVAd5vC0vgOz08vwyZB3KEmMLhclmCf';

const CONFIG = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + AUTHORIZATION_TOKEN,
  },
};

const PARAMS = {
  withLogin: false,
};

const APP_CONFIG = {
  currency: {
    symbol: 'DHS',
    position: 'right-spaced' as CurrencyPosition,
    positions: CURRENCY_POSITIONS,
  },
  ui: {
    hideProfileMenu: false,
    showMenuByDefault: false,
    notificationsEnabled: false,
  },
  style: STYLE_CONFIG,
  maps: {
    googleApiKey: 'AIzaSyCq1QD6BJbDJIgftxYpEjaT7MuyWqFxS_I',
  },
  location: {
    latitude: 33.5764642,
    longitude: -7.6496133,
    selectionRadiusKm: 5,
  },
  checkout: {
    defaultCurrency: 'DHS',
    paymentMethods: ['cash', 'carte', 'virement instantanée'],
  },
  language: {
    default: 'fr',
    supported: ['en', 'fr'],
  },
} as const;

export {
  BASE_URL,
  AUTHORIZATION_TOKEN,
  ENDPOINTS,
  CONFIG,
  DEBUG,
  PARAMS,
  APP_CONFIG,
  STYLE_CONFIG,
  resolveStyleConfig,
  CURRENCY_POSITIONS,
};

export type {CurrencyPosition};
